import type { ReportIssueContext } from "@/lib/feedback/types";

export const REPORT_ISSUE_EVENT = "repackify:report-issue";

export type ReportIssueEventDetail = ReportIssueContext;

export function isReportIssueEventDetail(
  value: unknown,
): value is ReportIssueEventDetail {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function openReportIssueDialog(context: ReportIssueEventDetail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ReportIssueEventDetail>(REPORT_ISSUE_EVENT, {
      detail: context,
    }),
  );
}
